import { Classes } from 'jss';
import { createUseStyles } from 'react-jss';
import { ActionPalette, BrandPalette, GrayscalePalette } from '@tcl-boron-colors/colors';

interface HeroButtonStylesData {
  disabled: boolean;
  minWidth: string;
}

export const useHeroButtonStyles: (data: HeroButtonStylesData) => Classes<'root'> = createUseStyles({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '68px',
    minWidth: ({ minWidth }: HeroButtonStylesData) => `${Math.max(parseInt(minWidth), 350)}px`,
    outline: 'none',
    borderRadius: '10px',
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: 'transparent',
    padding: '0',
    // Allow for vertical position change on hover.
    position: 'relative',
    top: '0',
    transition: 'top 150ms ease-out',
    cursor: ({ disabled }: HeroButtonStylesData) => (disabled ? 'default' : 'pointer'),
    backgroundColor: 'white',
    boxShadow: `0px 3px 4px 2px ${GrayscalePalette[300]}`,
    '&:hover': {
      top: ({ disabled }: HeroButtonStylesData) => (disabled ? 'auto' : '-5px'),
    },
    '&:focus-visible': {
      borderColor: ActionPalette[300],
    },
  },
  logoContainer: {
    margin: '0px 21px',
    color: ({ disabled }: HeroButtonStylesData) => (disabled ? GrayscalePalette[400] : BrandPalette[700]),
  },
});
